<template>
  <div class="user-account-settings">
    <div class="user-information mb-12 md:mb-8">
      <p class="text-sm" style="grid-area: name-key">Name</p>
      <p class="text-sm font-bold" style="grid-area: name">{{ userName }}</p>

      <p class="text-sm" style="grid-area: email-key">Email</p>
      <p class="text-sm" style="grid-area: email">{{ userEmail }}</p>
    </div>

    <settings-cell
      class="cursor-pointer hover:font-bold"
      icon-class="bdg-icon lock fa-fw"
      @click.native="changePassword()"
    >
      Change password
    </settings-cell>
  </div>
</template>

<script>
import SettingsCell from "../../elements/list-view/list-view-cells/SettingsCell";
import { SettingsTabs } from "../../js-data/tab-groups";
import UpdatePasswordModal from "../modals/UpdatePasswordModal";

export default {
  name: "UserAccountSettings",
  components: { SettingsCell },
  data() {
    return {
      showModal: false,
      changePasswordData: {
        currentPassword: "",
        newPassword: "",
        newPasswordConfirm: ""
      },
      passwordChangeLoading: false,
      tabs: SettingsTabs,
      selectedTab: null
    };
  },
  computed: {
    userName() {
      return this.$store.state.userName;
    },
    userEmail() {
      return this.$store.state.userEmail;
    }
  },
  methods: {
    changePassword() {
      this.$store.commit("setModalParams", {
        isShown: true,
        component: UpdatePasswordModal
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-account-settings {
  @apply w-full px-4;

  @screen md {
    @apply w-1/2 min-w-128 px-0;
  }

  @screen lg {
    @apply w-1/3;
  }

  .user-information {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-rows: auto auto;
    grid-template-areas:
      "name-key name"
      "email-key email";
    grid-row-gap: 7px;
    grid-column-gap: 20px;
  }
}
</style>
